import createReducer from './reducers';
import createActions from './actions';
import getSelectors from './selectors';
import getTypes from './types';
import createSagaFor from './saga';

export const storeName = 'registrationForm';
export const reducers = createReducer(storeName);
export const actions = createActions(storeName);
export const selectors = getSelectors(storeName);
export const types = getTypes(storeName);
export const sagaFactory = createSagaFor(storeName);
